class HshCollectionLoader extends HTMLElement {
  connectedCallback() {
    this.failed = false;
    this.busy = false;
    this.controller = new AbortController();
    this.addEventListener('click', this.onClick, { signal: this.controller.signal });
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.load();
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.request?.abort();
    this.observer?.disconnect();
  }
  onClick = (event) => {
    const link = event.target.closest('[data-hsh-next]');
    if (!link || this.failed || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.load();
  };
  async load() {
    const link = this.querySelector('[data-hsh-next]');
    if (!link || this.busy || this.failed || !this.isConnected) return;
    const scope = this.closest('results-list');
    const grid = scope?.querySelector('[ref="grid"]');
    if (!grid) return;
    const href = link.href;
    const next = new URL(href, location.href);
    if (next.origin !== location.origin || next.pathname !== location.pathname) return;
    const status = this.querySelector('[data-hsh-status]');
    this.busy = true;
    grid.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    status.textContent = this.dataset.loading;
    this.request = new AbortController();
    const timeout = setTimeout(() => this.request.abort(), 15000);
    try {
      next.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(next, { signal: this.request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Page unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = html.querySelector('hsh-collection-loader');
      const incomingGrid = html.querySelector('[ref="grid"]');
      if (!incoming || !incomingGrid) throw new Error('Grid unavailable');
      if (!this.isConnected || scope.querySelector('[ref="grid"]') !== grid || link.href !== href) return;
      const known = new Set(Array.from(grid.querySelectorAll('[data-product-id]'), (card) => card.dataset.productId));
      const cards = Array.from(incomingGrid.querySelectorAll(':scope > [data-product-id]')).filter((card) => !known.has(card.dataset.productId));
      if (!cards.length) throw new Error('No new products');
      grid.append(...cards);
      const nextLink = incoming.querySelector('[data-hsh-next]');
      if (nextLink) {
        const following = new URL(nextLink.getAttribute('href'), location.href);
        following.searchParams.delete('section_id');
        link.href = following.pathname + following.search;
        status.textContent = '';
      } else {
        link.remove();
        status.textContent = this.dataset.complete;
        this.observer?.disconnect();
      }
      scope.dispatchEvent(new CustomEvent('hsh:products-loaded', { bubbles: true, detail: { count: cards.length } }));
    } catch (error) {
      if (!this.isConnected) return;
      this.failed = true;
      this.observer?.disconnect();
      status.textContent = this.dataset.error;
    } finally {
      clearTimeout(timeout);
      this.busy = false;
      grid.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
    }
  }
}
if (!customElements.get('hsh-collection-loader')) customElements.define('hsh-collection-loader', HshCollectionLoader);
